// DOSYA YOLU: src/services/firestoreResultService.js

import { db } from "../firebase";
import { doc, setDoc, serverTimestamp } from "firebase/firestore";

/**
 * Kullanıcının test sonucunu Firestore'a kaydeder.
 * @param {string} userId - Kullanıcı ID
 * @param {string} testKey - Test tipi (disc, ocean, riasec)
 * @param {Object} data - { answers, scores, isCompleted }
 */
export async function saveTestResult(userId, testKey, data) {
    try {
        // users -> {uid} -> answers -> {testKey} yoluna kaydeder
        const resultRef = doc(db, "users", userId, "answers", testKey);
        
        await setDoc(resultRef, {
            ...data,
            userId: userId,
            testKey: testKey,
            submittedAt: serverTimestamp() // Sunucu zamanı
        }, { merge: true });

        console.log(`${testKey} sonucu başarıyla kaydedildi.`);
        return true;
    } catch (error) {
        console.error("Sonuç kaydetme hatası:", error);
        throw error;
    }
}